var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMeta(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 70,
    viewBox: "0 0 105 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6733 45.5625C11.6733 49.5343 12.5447 52.5833 13.6844 54.428C15.1784 56.8444 17.4066 57.87 19.6783 57.87C22.6079 57.87 25.2883 57.1428 30.4534 49.9987C34.5925 44.2729 39.4675 36.2356 42.7483 31.1968L48.3042 22.6603C52.1636 16.7318 56.6308 10.1415 61.7528 5.6743C65.9355 2.02798 70.4449 0.00244141 74.9844 0.00244141C82.606 0.00244141 89.8655 4.41907 95.4215 12.7025C101.502 21.7741 104.453 33.201 104.453 44.9926C104.453 52.0029 103.072 57.1537 100.72 61.2231C98.4491 65.1583 94.0216 69.0904 86.5738 69.0904V57.8682C92.9511 57.8682 94.5422 52.0082 94.5422 45.302C94.5422 35.7455 92.3141 25.1402 87.4056 17.5622C83.9226 12.1871 79.4084 8.90279 74.442 8.90279C69.0703 8.90279 64.7478 12.9547 59.8898 20.1772C57.307 24.0153 54.6558 28.692 51.6787 33.9696L48.4014 39.7752C41.8189 51.4496 40.1511 54.1073 36.8594 58.4939C31.0904 66.1761 26.1636 69.0887 19.6783 69.0887C11.9844 69.0887 7.11941 65.7569 4.10615 60.7364C1.64666 56.6457 0.438477 51.2775 0.438477 45.1612L11.6733 45.5625Z",
    fill: "#0081FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29712 13.4926C14.4479 5.55297 21.8813 0.000488281 30.4069 0.000488281C35.3442 0.000488281 40.2536 1.46181 45.3782 5.64708C50.9848 10.2219 56.9603 17.7594 64.4154 30.1766L67.0884 34.6316C73.5415 45.3819 77.2127 50.9126 79.3615 53.5207C82.1247 56.8699 84.06 57.8685 86.574 57.8685C92.9512 57.8685 94.5424 52.0084 94.5424 45.3022L104.454 44.9911C104.454 52.0014 103.072 57.1522 100.721 61.2216C98.4493 65.1568 94.0217 69.0889 86.574 69.0889C81.9439 69.0889 77.8422 68.0833 73.3062 63.8039C69.8207 60.5197 65.7426 54.6853 62.6064 49.4404L53.2778 33.8578C48.5976 26.0376 44.3025 20.2067 41.8191 17.5659C39.1456 14.7261 35.7093 11.2972 30.2257 11.2972C25.7877 11.2972 22.0185 14.4115 18.8645 19.1754L9.29712 13.4926Z",
    fill: "url(#paint0_linear_1495_421)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2256 11.2972C25.7876 11.2972 22.0184 14.4115 18.8644 19.1754C14.4042 25.9068 11.6755 35.9335 11.6755 45.5623C11.6755 49.5341 12.5468 52.5831 13.6866 54.4278L4.10615 60.7362C1.64666 56.6455 0.438477 51.2773 0.438477 45.161C0.438477 34.0382 3.49138 22.4453 9.297 13.4926C14.4478 5.55297 21.8812 0.000488281 30.4068 0.000488281L30.2256 11.2972Z",
    fill: "url(#paint1_linear_1495_421)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1495_421",
    x1: 22.9866,
    y1: 32.7542,
    x2: 94.606,
    y2: 36.3713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0064E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#0064E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#0073EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0082FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1495_421",
    x1: 15.4224,
    y1: 50.2791,
    x2: 15.4224,
    y2: 23.8739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0082FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064E0"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeta);
export default __webpack_public_path__ + "static/media/meta.0097bedb19eeb91cb16430473788c3e7.svg";
export { ForwardRef as ReactComponent };